import React from "react";
import "./TradeTable.scss";
import ReactTable from "../../../ReactTable/ReactTable";
import moment from "moment";

const TradeTable = ({ selectedDateValue }) => {
  const columns = [
    {
      Header: "Open Time",
      accessor: "openTime",
      Cell: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY / HH:mm:ss") : "-";
      },
    },
    {
      Header: "Action",
      accessor: "action",
    },
    {
      Header: "Symbol",
      accessor: "symbol",
    },
    {
      Header: "Volume",
      accessor: "volume",
    },
    {
      Header: "P&L",
      accessor: "profit",
      Cell: ({ value }) => (
        <div
          className={`${value > 0 ? "profit" : value < 0 ? "loss" : "normal"}`}
        >
          {value >= 0
            ? `$${value.toFixed(2)}`
            : `-$${Math.abs(value).toFixed(2)}`}
        </div>
      ),
    },
    {
      Header: "Commission",
      accessor: "commission",
    },
  ];

  const normalizedData = selectedDateValue?.map((trade) => ({
    openTime: trade.date || trade.tradeDateTime,
    action: trade.action || trade.side,
    symbol: trade.symbol || trade.instrument,
    volume: trade.volume || trade.lots||0,
    profit: parseFloat(trade.profit) || 0,
    commission: parseFloat(trade.commission) || 0,
  })) || [];

  return (
    <div className="tradeTableContainer">
      <div className="tradeTableWrapper">
        <ReactTable columns={columns} data={normalizedData} />
      </div>
    </div>
  );
};

export default TradeTable;